export const items = [
    {
        id: 0,
        name: 'black converse',
        sizes: [43, 44, 45],
        price: 180,
        image: [
            '/images/black (2).jpg',
            '/images/black (1).jpg',
            '/images/black (3).jpg',
            '/images/black (4).jpg',
        ],
        inStock: 10,
        amount: 1,
        chossenSize: 'choose your size from the bag page pls!'

    },
    {
        id: 1,
        name: 'blue converse',
        sizes: [41, 42, 43, 44, 45],
        price: 170,
        image: [
            '/images/blue (0).avif',
            '/images/blue (1).jpg',
            '/images/blue (2).jpg',
            '/images/blue (3).jpg',
        ],
        inStock: 8,
        amount: 1,
        chossenSize: 'choose your size from the bag page pls!'

    },
    {
        id: 2,
        name: 'green converse',
        sizes: [41, 42, 43, 44, 45],
        price: 150,
        image: [
            '/images/green (1).png',
            '/images/green (2).jpg',
            '/images/green (3).jpg',
            '/images/green (4).jpeg',
        ],
        inStock: 6,
        amount: 1,
        chossenSize: 'choose your size from the bag page pls!'
    },
    {
        id: 3,
        name: 'red converse',
        sizes: [40, 41, 43, 44, 45],
        price: 140,
        image: [
            '/images/red (0).avif',
            '/images/red (1).jpg',
            '/images/red (2).jpg',
            '/images/red (3).jpg',
        ],
        inStock: 4,
        amount: 1,
        chossenSize: 'choose your size from the bag page pls!'

    },
    {
        id: 4,
        name: 'white converse',
        sizes: [40, 41, 42, 43, 44],
        price: 130,
        image: [
            '/images/white (0).avif',
            '/images/white (1).jpg',
            '/images/white (2).jpg',
            '/images/white (3).jpg',
        ],
        inStock: 3,
        amount: 1,
        chossenSize: 'choose your size from the bag page pls!'

    },
    {
        id: 5,
        name: 'black & white converse',
        sizes: [40, 41, 42, 44, 45],
        price: 120,
        image: [
            '/images/white_black (0).avif',
            '/images/white_black (1).jpg',
            '/images/white_black (2).jpg',
            '/images/white_black (3).jpg',
        ],
        inStock: 2,
        amount: 1,
        chossenSize: 'choose your size from the bag page pls!'

    },
    {
        id: 6,
        name: 'yellow converse',
        sizes: [40, 45],
        price: 120,
        image: [
            '/images/yellow (0).avif',
            '/images/yellow (1).jpg',
            '/images/yellow (2).jpg',
            '/images/yellow (3).jpg',
        ],
        inStock: 2,
        amount: 1,
        chossenSize: 'choose your size from the bag page pls!'
    },
]